import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styles from './AgencyCards.scss';
import {
  dataLayerPush,
  trackBeginCheckout,
  trackContactAgent,
  trackClickReveal,
} from '../../lib/tracking';
import {getAuctionSaleType} from '../../selectors/openn';

const getMainAgentForProperty = (propertyDetail) => {
  let agent = propertyDetail.property?.listing?.agency?.agents?.length > 0 ? propertyDetail.property?.listing?.agency?.agents[0] : {};
  if(propertyDetail?.property?.recentlySold) {
    agent = propertyDetail.property?.lastSale?.sellingAgency?.agents.length > 0 ? propertyDetail.property?.lastSale?.sellingAgency?.agents[0] : {};
  }
  return agent;
};

const getAgentId = (props, agentDetail, propertyDetail) => {
  const {context, agent} = props;
  if (agent) return agent.uuid;
  else {
    if (context === 'agent') {
      return agentDetail?.detail?.uuid;
    } else if (context === 'pdp') {
      return getMainAgentForProperty(propertyDetail)?.uuid;
    }
  }
};

const getDataSourceDetail = (propertyDetail, agencyDetail, agentDetail, context) => {
  if (context === 'agent') {
    return agentDetail?.detail;
  } else if (context === 'agency') {
    return agencyDetail?.detail;
  }
  return propertyDetail?.property;
};

function trackClick(trackEvent, dataSourceDetail, user, agencyId, agentId, context, opennActionSaleType) {
  dataLayerPush({event: trackEvent});

  if (context === 'pdp' || context === 'agent' || context === 'agency') {
    trackBeginCheckout(dataSourceDetail, agencyId, agentId, dataSourceDetail?.id, opennActionSaleType);
  }
  trackContactAgent(user?.currentUser?.preferences?.CONSUMER_TYPE, user?.currentUser?.preferences?.FINANCE_POSITION,
    agencyId, 'Call', dataSourceDetail, agentId);
}

function ClickToContactDesktop(props) {
  const propertyDetail = useSelector(state => state.propertyDetail);
  const agencyDetail = useSelector(state => state.agencyDetail);
  const agentDetail = useSelector(state => state.agentDetail);
  const opennAuction = useSelector(state => state.opennAuction);
  const user = useSelector(state => state.user);
  const [showNumbers, setNumbersShowing] = useState(false);
  let postFix = '-callDesktop';
  if (props.display && props.display == 'mobileDesktop') postFix = '-callMobile';
  let eventName = 'ctcd';
  const dataSourceDetail = getDataSourceDetail(propertyDetail, agencyDetail, agentDetail, props.context);
  const agentId = getAgentId(props, agentDetail, propertyDetail);
  const opennAuctionSaleType = getAuctionSaleType(opennAuction);

  const showDetails = (event) => {
    setNumbersShowing(true);
    if (props?.trackEvent) eventName = props.trackEvent;
    dataLayerPush({event: eventName + '-ShowNumbers'});
    trackClickReveal({
      user,
      suburb: dataSourceDetail?.address?.suburb,
      postcode: dataSourceDetail?.address?.postCode,
      state: dataSourceDetail?.address?.stateCode,
      agencyId: props.agencyID,
      agentId: getAgentId(props, agentDetail, propertyDetail),
      category: dataSourceDetail?.category,
      listings: dataSourceDetail?.listings,
      recentlySold: dataSourceDetail?.recentlySold,
      listingId: dataSourceDetail?.id, // agencyDetail uses "agencyId", agentDetail uses "uuid". defaults to fallback unless pdp
      propertyDetail: propertyDetail,
    });


    if (props.context === 'pdp' || props.context === 'agent' || props.context === 'agency') {
      trackBeginCheckout(dataSourceDetail, props.agencyID, agentId, dataSourceDetail?.id, getAuctionSaleType(opennAuction));
    }
  };

  return (
    (props.contact.phone.business || props.contact.phone.mobile) ?
      showNumbers ?
        <div className={styles.clickContact}>
          {props.contact.phone.business ? <a onClick={() => trackClick(eventName + postFix, dataSourceDetail, user, props.agencyID, agentId, props.context, opennAuctionSaleType, propertyDetail)} href={"tel:" + props.contact.phone.business}>{props.contact.phone.business}</a>: null}
          {props.contact.phone.business && props.contact.phone.mobile ? ' | ' : null}
          {props.contact.phone.mobile ? <a onClick={() => trackClick(eventName + postFix, dataSourceDetail, user, props.agencyID, agentId, props.context, opennAuctionSaleType, propertyDetail)} href={"tel:" + props.contact.phone.mobile}>{props.contact.phone.mobile}</a>: null}
        </div>
        :
        <div className={styles.clickContact} onClick={showDetails}>Show contact details</div>
      : null
  );
}

function ClickToContactMobile(props) {
  const propertyDetail = useSelector(state => state.propertyDetail);
  const agencyDetail = useSelector(state => state.agencyDetail);
  const agentDetail = useSelector(state => state.agentDetail);
  const user = useSelector(state => state.user);
  const opennAuction = useSelector(state => state.opennAuction);
  let callNumber = null;
  const dataSourceDetail = getDataSourceDetail(propertyDetail, agencyDetail, agentDetail, props.context);
  const agentId = getAgentId(props, agentDetail, propertyDetail);
  let eventName = props?.trackEvent;
  if (!eventName) eventName = 'agentProfileContact';
  if (props.contact.phone.mobile) callNumber = props.contact.phone.mobile;
  else if (props.contact.phone.business) callNumber = props.contact.phone.business;
  return (
    callNumber ?
      <div className={styles.clickContact}><a onClick={() => trackClick(eventName + '-callMobile', dataSourceDetail, user, props.agencyID, agentId, props.context, getAuctionSaleType(opennAuction), propertyDetail)} href={"tel:" + callNumber}>Call {props.context === 'pdp' ? 'agent' : props.context}</a></div>
    : null
  );
}

function ClickToContactAgent(props) {
  let [displayType, setDisplay] = useState('responsive');

  useEffect(() => { // mount
    if (props.displayMode) setDisplay(props.displayMode);
  }, []);

  return (
    props.contact && props.contact.phone ?
      displayType == 'responsive' ?
        <React.Fragment>
          <div className="d-none d-lg-flex mt-1 mb-2"><ClickToContactDesktop agencyID={props.agencyID} contact={props.contact} trackEvent={props.trackEvent} {...props} /></div>
          <div className="d-flex d-lg-none mt-1 mb-2"><ClickToContactMobile agencyID={props.agencyID} contact={props.contact} trackEvent={props.trackEvent} context={props.context} {...props} /></div>
        </React.Fragment>
      : displayType == 'desktop' ?
        <div className="d-flex mt-1 mb-2"><ClickToContactDesktop agencyID={props.agencyID} contact={props.contact} trackEvent={props.trackEvent} {...props} /></div>
      : displayType = 'mobile' ?
        <div className="d-flex mt-1 mb-2"><ClickToContactMobile agencyID={props.agencyID} contact={props.contact} trackEvent={props.trackEvent} context={props.context} {...props} /></div>
      : displayType == 'mobileDesktop' ?
        <div className="d-flex mt-1 mb-2"><ClickToContactDesktop agencyID={props.agencyID} display={display} contact={props.contact} trackEvent={props.trackEvent} {...props} /></div>
      :null
    : null
  );
}

ClickToContactAgent.propTypes = {
  agencyID: PropTypes.string.isRequired,
  agent: PropTypes.object,
  contact: PropTypes.object.isRequired,
  context: PropTypes.oneOf(['agent', 'agency', 'pdp']).isRequired,
  trackEvent: PropTypes.string,
  displayMode: PropTypes.string, // responsive/desktop/mobile/mobileDesktop
};

export default ClickToContactAgent;
